/**
 * PRNG sembrado (mulberry32). No usamos retos diarios ni fantasmas, pero
 * mantener la aleatoriedad sembrada cuesta cero y deja abierta la puerta a
 * verificar partidas por replay en el servidor mas adelante.
 *
 * Regla: ningun archivo dentro de src/sim usa Math.random directamente.
 */

let state = 0;

export function seed(s: number): void {
  state = s >>> 0;
}

export function currentSeed(): number {
  return state;
}

export function random(): number {
  state = (state + 0x6d2b79f5) >>> 0;
  let t = state;
  t = Math.imul(t ^ (t >>> 15), t | 1);
  t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
  return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
}

/** entero en [0, n) */
export const ri = (n: number): number => Math.floor(random() * n);

/** entero en [a, b] inclusivo */
export const rr = (a: number, b: number): number => a + ri(b - a + 1);

/** Generador independiente, para escenografia derivada del numero de ola. */
export function seededGen(s: number): () => number {
  let x = (s * 2654435761) >>> 0;
  return () => {
    x = (x * 1664525 + 1013904223) >>> 0;
    return x / 4294967296;
  };
}
